import type { LDFlagSet } from "launchdarkly-js-client-sdk";

/**
 * Flag values from the server bootstrap payload, without the SDK's `$flagsState` / `$valid` metadata.
 * Returns undefined when the bootstrap is missing or the server marked its evaluation invalid.
 */
export function bootstrapFlags(bootstrap?: LDFlagSet): LDFlagSet | undefined {
  if (!bootstrap || bootstrap.$valid === false) {
    return undefined;
  }
  return Object.fromEntries(
    Object.entries(bootstrap).filter(([key]) => !key.startsWith("$")),
  );
}
